import React from 'react'
import {Col, Container, Row} from 'react-bootstrap'
import logo from '../assets/img/Logo_Izzi.svg';

export const Footer = () => {



    const DUENO_PROYECTO = {name: 'Williams Camacho', email: 'wcamacho@izzi.mx'}

    return (
        <footer className="footer">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={3} className="text-center text-md-start mb-2 mb-md-0">
                        <img src={logo} alt="logo" style={{width: '80px'}}/>
                    </Col>
                    <Col xs={12} md={6} className="text-center mb-2 mb-md-0">
                        <p className="m-0" style={{fontSize: '12px'}}>© 2024, izzi.mx. Todos los derechos reservados.</p>
                    </Col>
                    <Col xs={12} md={3} className="text-center text-md-end">
                        <h6 className="m-0" style={{fontSize: '12px', fontWeight: 'bold'}}>Dueño de la información</h6>
                        <p className="m-0" style={{fontSize: '12px'}}>{DUENO_PROYECTO.name}</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};